<template>
    <form class="mx-auto">
        <div class="loader" v-if="loading"></div>
        <div v-if="!loading">
            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="backToRegister">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('personalData') }}</div>
                </div>
                <div class="card-body">
                    <person :person="lector.person"
                            :show-extended="true"
                            :requiredIdentification="false"></person>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.lectors.livingAddress') }}</div>
                </div>
                <div class="card-body">
                    <app-address
                        :address="lector.livingAddress"
                        :street-required="false"
                    />
                </div>
            </div>
            <!--<div class="card mt-3">
        <div class="card-header bg-primary text-white">
            <div class="h5">{{ $t('address.cardTitle') }}</div>
        </div>
        <div class="card-body">
            TODO:
        </div>
    </div>-->
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.lectors.teachingData') }}</div>
                </div>
                <div class="card-body row">
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold required" :for="'thematicArea' + _uid">
                            {{
                            $t('registers.lectors.thematicArea')
                            }}
                        </label>
                        <dynamic-multi-select :api-url="`/api/Dropdown/GetThematicAreas`"
                                              v-validate="'required'"
                                              v-model="lector.thematicAreaIds"
                                              :show-add-thematic-area-btn="true"
                                              :name="'registers.lectors.thematicArea' + _uid"
                                              :data-vv-as="$t('registers.lectors.thematicArea')"
                                              :fieldName="$t('registers.lectors.thematicArea')"></dynamic-multi-select>

<!--                        <dynamicDropdown :apiUrl="`/api/Dropdown/GetThematicAreas`"-->
<!--                                         v-model="lector.thematicAreaId"-->
<!--                                         v-validate="'required'"-->
<!--                                         :id="'registers.lectors.thematicArea' + _uid"-->
<!--                                         :name="'registers.lectors.thematicArea' + _uid"-->
<!--                                         :data-vv-as="$t('registers.lectors.thematicArea')"-->
<!--                                         :fieldName="$t('registers.lectors.thematicArea')"></dynamicDropdown>-->
                        <span class="text-danger" v-if="errors.has('registers.lectors.thematicArea' + _uid)">{{ errors.first('registers.lectors.thematicArea' + _uid) }}</span>
                        <!--<nomenclature-dropdown :type="'Тематична област'" v-model="lector.thematicAreaId"
                       :required="true" :fieldName="$t('registers.lectors.thematicArea')"></nomenclature-dropdown>-->
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'themes' + _uid">
                            {{
                            $t('registers.lectors.themes')
                            }}
                        </label>
                        <dynamic-multi-select :api-url="`/api/Lectors/GetThemesForDropdown`"
                                              v-model="lector.themesIds"
                                              :request-params="lector.thematicAreaIds"
                                              :fieldName="$t('registers.lectors.themes')"></dynamic-multi-select>
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'lectorTrainings' + _uid">
                            {{
                            $t('registers.lectors.lectorsTeaching')
                            }}
                        </label>
                        <toggle v-model="lector.lectorsTeaching"></toggle>
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'universityTraining' + _uid">
                            {{
                            $t('registers.lectors.universityTeaching')
                            }}
                        </label>
                        <toggle v-model="lector.universityTeaching"></toggle>
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'universityTraining' + _uid">
                            {{
                            $t('registers.lectors.nipTeaching')
                            }}
                        </label>
                        <toggle v-model="lector.nipTeaching"></toggle>
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'teachingPractitioners' + _uid">
                            {{
                            $t('registers.lectors.practitionersTeaching')
                            }}
                        </label>
                        <toggle v-model="lector.practitionersTeaching"></toggle>
                    </div>
                    <div class="form-group col-lg-6">
                        <label :for="'status' + _uid" class="font-weight-bold required">
                            {{
                            $t('registers.lectors.status')
                            }}
                        </label>
                        <nomenclature-dropdown :load-by-parent-sort="true"
                                               :parent-sort="nomenclature.LectorStatus"
                                               :required="true"
                                               v-model="lector.lectorStatusId"
                                               :fieldName="$t('registers.lectors.status')"></nomenclature-dropdown>
                    </div>
                    <div class="col-12">
                        <label class="font-weight-bold" :for="'notes' + _uid">
                            {{
                            $t('registers.lectors.notes')
                            }}
                        </label>
                        <textarea class="form-control" :id="'notes' + _uid" v-model="lector.notes"></textarea>
                    </div>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.lectors.reasonForJoiningLikeLector') }}</div>
                </div>
                <div class="card-body row">
                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'basisForInclusion' + _uid">
                            {{
                            $t('registers.lectors.reasonForJoining')
                            }}
                        </label>
                        <nomenclature-dropdown :load-by-parent-sort="true"
                                               :parent-sort="nomenclature.ReasonForJoining"
                                               v-model="lector.reasonForJoiningAsTeacherId"
                                               :fieldName="$t('registers.lectors.reasonForJoining')"></nomenclature-dropdown>
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'managementBoardDecision' + _uid">
                            {{
                            $t('registers.lectors.decision')
                            }}
                        </label>
                        <input type="text" class="form-control" :id="'managementBoardDecision' + _uid"
                               v-model="lector.decisionForJoining">
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'decisionDate' + _uid">
                            {{
                            $t('registers.lectors.decisionDate')
                            }}
                        </label>
                        <datepicker v-model="lector.decisionForJoiningDate"></datepicker>
                    </div>
                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'additionalInfo' + _uid">
                            {{
                            $t('registers.lectors.additionalInfo')
                            }}
                        </label>
                        <input type="text" class="form-control" :id="'additionalInfo' + _uid"
                               v-model="lector.additionalInfoForJoining">
                    </div>
                    <!--                <div class="form-group col-lg-6">
                <label :for="'contractSubject' + _uid" class="font-weight-bold">Предмет на договора</label>
                <input type="text" class="form-control" :id="'contractSibject' + _uid">
            </div>-->
                    <!--<div class="form-group col-lg-6">
                <label :for="'contractPreparedBy' + _uid" class="font-weight-bold">Изготвил договора</label>
                // TODO:
            </div>
            <div class="form-group col-lg-6">
                <label :for="'contractTime' + _uid" class="font-weight-bold">Срок на договора</label>
                // TODO:
            </div>-->
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.lectors.reasonForReleaseLikeTeacher') }}</div>
                </div>
                <div class="card-body row">
                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'basisForInclusion' + _uid">
                            {{
                            $t('registers.lectors.reasonForRelease')
                            }}
                        </label>
                        <nomenclature-dropdown :load-by-parent-sort="true"
                                               :parent-sort="nomenclature.ReasonForRelease"
                                               v-model="lector.reasonForReleaseOfTeacherId"
                                               :fieldName="$t('registers.lectors.reasonForRelease')"></nomenclature-dropdown>
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'managementBoardDecision' + _uid">
                            {{
                            $t('registers.lectors.decision')
                            }}
                        </label>
                        <input type="text" class="form-control" :id="'managementBoardDecision' + _uid"
                               v-model="lector.decisionForRelease">
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'decisionDate' + _uid">
                            {{
                            $t('registers.lectors.decisionDate')
                            }}
                        </label>
                        <datepicker v-model="lector.decisionForReleaseDate"></datepicker>
                    </div>
                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'additionalInfo' + _uid">
                            {{
                            $t('registers.lectors.additionalInfo')
                            }}
                        </label>
                        <input type="text" class="form-control" :id="'additionalInfo' + _uid"
                               v-model="lector.additionalInfoForRelease">
                    </div>
                    <!--                <div class="form-group col-lg-6">
                <label :for="'contractSubject' + _uid" class="font-weight-bold">Предмет на договора</label>
                <input type="text" class="form-control" :id="'contractSibject' + _uid">
            </div>-->
                    <!--<div class="form-group col-lg-6">
                <label :for="'contractPreparedBy' + _uid" class="font-weight-bold">Изготвил договора</label>
                // TODO:
            </div>
            <div class="form-group col-lg-6">
                <label :for="'contractTime' + _uid" class="font-weight-bold">Срок на договора</label>
                // TODO:
            </div>-->
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="h5">{{ $t('registers.lectors.cv') }}</div>
                </div>
                <div class="card-body">
                    <div v-show="!showCV">
                        <div class="card-body k-display-flex">
                            <file-download :file="lector.cvDetails"
                                           class="col-12"
                                           :type="lector.cvDetails.docTypeCode">
                            </file-download>
                            <i class="fas fa-trash-alt k-align-self-center btn-danger pointer position-relative"
                               @click="removeCV(lector.cvDetails)"></i>
                        </div>
                    </div>
                    <div v-show="showCV">
                        <div class="card-body k-display-flex">
                            <file-upload :file="lector.cv" class="col-12"></file-upload>
                            <i class="fas fa-trash-alt k-align-self-center btn-danger pointer position-relative"
                               @click="removeCV(lector.cv)"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.lectors.attachedDocuments') }}</div>
                </div>
                <div class="card-body">
                    <div v-for="(document,index) in lector.documents"
                        :key="index" class="mt-2 border border-light-2 p-2 k-display-flex">
                        <file-download :file="document"
                                       class="col-12"
                                       :type="document.docTypeCode">
                        </file-download>
                        <i class="fas fa-trash-alt k-align-self-center btn-danger pointer position-relative"
                           @click="removeDocument(document,index)"></i>
                    </div>
                    <div v-for="(file,index) in lector.files" :key="index" class="mt-2 border border-light-2 p-2 k-display-flex">
                        <file-upload :file="file" class="col-12"></file-upload>
                        <i class="fas fa-trash-alt k-align-self-center btn-danger pointer position-relative"
                           @click="removeFile(index)"></i>
                    </div>
                    <button type="button" class="btn btn-secondary mt-3" @click="addFile">
                        {{
                        $t('publicOrder.addFile')
                        }}
                    </button>
                </div>
            </div>
            <div class="card mt-3" v-if="id">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.lectors.contractData') }}</div>
                </div>
                <div>
                    <contracts-list-grid ref="lecturerContracts" :lecturerId="Number(id)"></contracts-list-grid>
                </div>
            </div>
            <div class="card mt-3" v-if="id">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('eventDocuments.title') }}</div>
                </div>
                <div v-if="showEventDocs">
                    <lecturer-event-docs ref="lecturerEventDocs" :lecturerId="Number(id)"></lecturer-event-docs>
                </div>
            </div>
            <div class="card mt-3" v-if="id">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.lectors.eventsParticipation') }}</div>
                </div>
                <div>
                    <events-participation ref="lecturerEventParticipation"
                                          :lecturerId="Number(id)"></events-participation>
                </div>
            </div>

            <AuxiliaryRegister ref="auxiliaryRegisterRef"
                               :register-id="AuxiliaryRegisters.Lecturers"
                               register-name="Lector"
                               :entry-id="lector.auxRegisterEntityId"></AuxiliaryRegister>

            <div class="text-center mt-3">
                <button type="button" class="btn btn-primary btn" @click="onSubmit">
                    <i class="fas fa-save"></i>
                    {{ $t('buttons.save.btnText') }}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import PersonComponent from '../../../components/person/Person';
    import FileUpload from '../../../components/common/FileUpload';
    import FileDownload from '../../../components/common/FileDownload';
    import { Lector, InstitutionDetails } from '@/models/models';
    import { File } from '@/models/file.models';
    import DatePicker from '../../../components/datepicker/DatePicker';
    import NomenclatureDropdown from '../../../components/dropdown/NomenclatureDropdown';
    import Toggle from '../../../components/toggle/Toggle';
    import { LectorsDocumentTypes, NomenclatureParentBySort, AuxiliaryRegisters } from '@/models/enums';
    import Address from '../../../components/address/Address';
    import DynamicMultiSelect from '../../../components/dropdown/DynamicMultiSelect';
    import ParticipationEventDocs from '../../../components/docs/ParticipationEventDocs';
    import EventParticipation from '../lectors/LectorsParticipationGrid';
    import ContractsListGrid from "../externalSupplier/ContractsGrid";
    import AuxiliaryRegister from '@/components/dynamic/AuxiliaryRegister';

    export default {
        components: {
            ContractsListGrid,
            DynamicMultiSelect,
            NomenclatureDropdown,
            Toggle,
            AuxiliaryRegister,
            'person': PersonComponent,
            'file-upload': FileUpload,
            'datepicker': DatePicker,
            'file-download': FileDownload,
            'app-address': Address,
            'lecturer-event-docs': ParticipationEventDocs,
            'events-participation': EventParticipation,
            'contracts-list-grid': ContractsListGrid
        },
        data() {
            return {
                nomenclature: NomenclatureParentBySort,
                id: '',
                lector: new Lector(),
                showCV: true,
                institution: new InstitutionDetails(),
                loading: false,
                showEventDocs: true,
                AuxiliaryRegisters: AuxiliaryRegisters
            }
        },
        methods: {
            addFile() {
                this.lector.files.push(new File({ fileName: '', description: '' }));
            },
            removeFile(index) {
                this.lector.files.splice(index, 1);
            },
            removeDocument(document, index) {
                this.lector.documents.splice(index, 1);
                this.lector.deletedDocumentsIds.push(document.id);
            },
            removeCV(file) {
                if (file.id !== '') {
                    this.lector.deletedCVid = file.id;
                    this.showCV = true;
                }
                this.lector.cv = new File({ fileName: '', description: '' });
            },
            onSubmit() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.lector.auxRegisterModel = this.$refs.auxiliaryRegisterRef.getDynamicRegisterModelForSubmit();
                        if (this.id) {
                            this.edit();
                        } else {
                            this.create();
                        }
                    }
                });
            },
            backToRegister() {
                this.$router.push('/registers/lectors/');
            },
            edit() {
                this.loading = true;
                this.$http.put('/api/lectors', this.lector).then(result => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                    this.uploadFiles(this.id);
                    this.backToRegister();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    });
                });
            },
            create() {
                this.loading = true;
                this.$http.post('/api/lectors/CreateLecturer', this.lector).then(result => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                    this.uploadFiles(result.data);
                    this.backToRegister();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    });
                });
            },
            uploadFiles(registerId) {
                // TODO: Loading with upload files text for example
                this.loading = true;
                if (this.lector.files.length > 0) {
                    let formData = new FormData();
                    let descriptions = [];
                    this.lector.files.forEach(file => {
                        formData.append('files', file.content, file.fileName);
                        descriptions.push({
                            fileName: file.fileName,
                            description: file.fileDescription,
                            typeId: LectorsDocumentTypes.File,
                            length: file.content.size
                        });
                    });

                    try {
                        const descJson = JSON.stringify(descriptions);
                        formData.append('descriptionJson', descJson);
                    } catch (e) {
                        console.error(e);
                    }

                    this.$http.post(`/api/Lectors/uploadfiles/${registerId}`, formData).then(result => {
                        this.backToRegister();
                        this.loading = false;
                        this.$vs.notify({
                            title: this.$t('notifications.success'),
                            text: this.$t('notifications.successUploadingFiles'),
                            position: 'top-center',
                            color: 'success'
                        });
                    }).catch(error => {
                        this.loading = false;
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
                }
                if (this.lector.cv.fileName !== '') {
                    let formData = new FormData();
                    let descriptions = [];
                    formData.append('files', this.lector.cv.content, this.lector.cv.fileName);
                    descriptions.push({
                        fileName: this.lector.cv.fileName,
                        description: this.lector.cv.fileDescription,
                        typeId: LectorsDocumentTypes.CV,
                        length: this.lector.cv.content.size
                    });
                    try {
                        const descJson = JSON.stringify(descriptions);
                        formData.append('descriptionJson', descJson);
                    } catch (e) {
                        console.error(e);
                    }

                    this.$http.post(`/api/Lectors/uploadfiles/${registerId}`, formData).then(result => {
                        this.backToRegister();
                        this.loading = false;
                        this.$vs.notify({
                            title: this.$t('notifications.success'),
                            text: this.$t('notifications.successUploadingFiles'),
                            position: 'top-center',
                            color: 'success'
                        });
                    }).catch(error => {
                        this.loading = false;
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
                } else {
                    this.backToRegister();
                }
            },
            loadData() {
                this.loading = true;
                this.$http.get(`/api/Lectors/${this.id}`).then(result => {
                    this.lector = new Lector(result.data);
                    if (this.lector.cvDetails.name !== '') {
                        this.showCV = true;
                    }
                    this.loading = false;
                }).catch(error => {
                    // TODO:
                });
            }
        },
        watch: {
            'lector.institutionId'(newVal, oldVal) {
                if (this.lector.institutionId !== undefined
                    && this.lector.institutionId !== '' &&
                    this.lector.institutionId != null) {
                    this.$http.get(`/api/Institution/GetDetails/${this.lector.institutionId}`).then(result => {
                        this.institution = new InstitutionDetails(result.data);
                    });
                }
                if (newVal === 0) {
                    this.lector.institutionId = '';
                }
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.id) {
                this.loadData();
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
